import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import rendezVousService from '../../../services/rendezVousService';
import { getRdvStatusActions } from '../rdvFormatters';

export default function RendezVousStatusActions({ rdv, onUpdated, toast, disabled = false }) {
  const [busy, setBusy] = useState('');
  const [cancelReason, setCancelReason] = useState('');
  const [showCancelReason, setShowCancelReason] = useState(false);

  const actions = getRdvStatusActions(rdv?.status);
  if (!rdv?.id || !actions.length) return null;

  const runAction = async (action) => {
    if (action === 'ANNULE') {
      if (!showCancelReason) {
        setShowCancelReason(true);
        return;
      }
      if (!cancelReason.trim()) {
        toast?.('warning', 'Indiquez un motif d’annulation');
        return;
      }
    }

    setBusy(action);
    try {
      let res;
      if (action === 'CONFIRME') res = await rendezVousService.confirm(rdv.id);
      else if (action === 'TERMINE') res = await rendezVousService.finish(rdv.id);
      else if (action === 'ANNULE') res = await rendezVousService.cancel(rdv.id, cancelReason.trim());
      else if (action === 'ABSENT') res = await rendezVousService.absent(rdv.id);

      if (res?.success) {
        toast?.('success', 'Statut mis à jour');
        setShowCancelReason(false);
        setCancelReason('');
        onUpdated?.(res.data);
      }
    } catch (e) {
      toast?.('danger', e.message || 'Changement de statut impossible');
    } finally {
      setBusy('');
    }
  };

  return (
    <div className="recv-rdv-status-actions">
      <div className="recv-rdv-status-actions__buttons">
        {actions.map(({ action, label, variant }) => (
          <Button
            key={action}
            size="sm"
            variant={variant}
            disabled={disabled || !!busy}
            onClick={() => runAction(action)}
          >
            {busy === action ? '…' : label}
          </Button>
        ))}
      </div>
      {showCancelReason ? (
        <div className="recv-rdv-status-actions__cancel mt-2">
          <Form.Label className="small mb-1">Motif d’annulation</Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            value={cancelReason}
            onChange={(e) => setCancelReason(e.target.value)}
            placeholder="Précisez la raison…"
            disabled={!!busy}
          />
          <div className="d-flex flex-wrap gap-2 mt-2">
            <Button size="sm" variant="danger" disabled={!!busy} onClick={() => runAction('ANNULE')}>
              Confirmer l’annulation
            </Button>
            <Button
              size="sm"
              variant="outline-secondary"
              disabled={!!busy}
              onClick={() => {
                setShowCancelReason(false);
                setCancelReason('');
              }}
            >
              Retour
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
}
